var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"printing-action"},[_c('naj-button',{attrs:{"square":"","size":"small"},on:{"click":_vm.print}},[_vm._v(" "+_vm._s(_vm.local.common.print)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }